var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCo2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.44,
    height: 12.649,
    viewBox: "0 0 17.44 12.649",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3f414a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -70.333)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.378,74.049a3.692,3.692,0,0,1,.857.1,5.352,5.352,0,0,1,4.306-2.155q.186,0,.369.013a3.4,3.4,0,0,0-5.885.049,2.142,2.142,0,0,0-2.993,1.554A2.218,2.218,0,0,0,.471,77.187a3.763,3.763,0,0,1,1.437-.7,3.7,3.7,0,0,1,3.47-2.441Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M245.476,320.04a.568.568,0,1,0,.506.564A.514.514,0,0,0,245.476,320.04Z",
    transform: "translate(-236.626 -241.201)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.927,152.518c0-.006,0-.011,0-.017a4.387,4.387,0,0,0-8.282-2.016A2.7,2.7,0,0,0,2.7,152.5a2.806,2.806,0,0,0,.1,5.61H14.634a2.806,2.806,0,0,0,.292-5.6Zm-8.7,2.582a.61.61,0,0,0,.493-.264l.481.429a1.22,1.22,0,0,1-1.013.451,1.183,1.183,0,1,1,0-2.361,1.22,1.22,0,0,1,1.013.451l-.481.429a.61.61,0,0,0-.493-.264.566.566,0,0,0,0,1.129Zm2.626.616a1.184,1.184,0,1,1,0-2.361,1.184,1.184,0,1,1,0,2.361Zm3.566-.052H10.608V155.2l.816-.755c.155-.145.177-.232.177-.31,0-.11-.074-.177-.219-.177a.369.369,0,0,0-.332.21l-.574-.287a1.035,1.035,0,0,1,.977-.522c.535,0,.913.277.913.706a.889.889,0,0,1-.387.719l-.323.293h.761v.59Z",
    transform: "translate(0 -75.133)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo2);
export default __webpack_public_path__ + "static/media/co2.e1804a16ba6f5ba8d66b9dd7040d492c.svg";
export { ForwardRef as ReactComponent };